import { coordinateEventName } from '@ui/events'

export const CLIP_PLANE_POINT_SELECTION_KEY = `${coordinateEventName}-clip-plane`
export const CLIP_PLANE_POINT_SELECTION_MESSAGE =
  'Klicken Sie 3 Punkte in der Szene an, um eine Schnittfläche zu erstellen'
